import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=7972bada"
import script from "./Matrix.vue?vue&type=script&lang=ts"
export * from "./Matrix.vue?vue&type=script&lang=ts"
import style0 from "./Matrix.vue?vue&type=style&index=0&id=7972bada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports